import { apiRequest } from '../../../shared/api/client';
import { sessionResponseSchema, userSchema } from './schemas';

export async function fetchAuthenticatedProfile(token: string) {
  return apiRequest('/users/me', {
    token,
    parse: userSchema.parse,
  });
}

export async function restoreSession(token: string) {
  const session = await apiRequest('/users/me/session', {
    token,
    parse: sessionResponseSchema.parse,
  });

  return {
    token,
    user: session.user,
    chain: session.chain,
    root: session.root,
  };
}
